export const langInfo = {
  1491988: 'en',
  1491973: 'th',
  1491937: 'id',
  8229847: 'zh-tw',
  1491963: 'zh-cn',
  40: 'ms',
  8: 'ja',
  9: 'ko',
  12: 'pt',
  14: 'es',
  54: 'ar',
  1491994: 'vi',
};
